import React, { useContext } from 'react';
import {
	ErrorTable,
	FileSummary,
	FileItem,
	FlexAlignRight,
	FileList,
	FileListWrapper,
	ImageWrapper,
	DownloadBtn,
	HeaderRow,
	HeaderValue,
	Wrapper,
	ButtonWrapper,
	RadioLabel,
	RadioContainer,
	NoteContainer,
	TableWrapper,
	ActionContainer,
	StepCount,
} from './ErrorLogs.styles';
import {
	ApButtonMain,
	ApButtonSecondary,
	ApIcon,
	ApRadio,
} from '@alixpartners/ui-components';
import { white } from 'styles/colors';
import { GenerateSpendCubeContext } from 'contexts/GenerateSpendCubeContext';
import { downloadEtlFile, triggerNormailzation } from 'utils/apiRequests';
import { Tooltip } from 'react-tippy';
import { useToastMessageContext } from 'contexts/ToastMessageContext/ToastMessageProvider';
import { NotificationTypes } from 'components/Toast/constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const ErrorLogs = ({ setCurrentLoadingMessage, logFiles }) => {
	const {
		isAutomation,
		setIsAutomation,
		setPageLoading,
		getCurrentEtlState,
		setIsShowRestartModal,
	} = useContext(GenerateSpendCubeContext);
	const { showToast } = useToastMessageContext();
	const history = useHistory();

	const downloadFile = () => {
		// 1: download link for unclassified file
		// 2: download link for excluded unclassified
		// 3: download link for summary file
		downloadEtlFile(2)
			.then(() => {})
			.catch(err => {
				console.error(err);
				showToast('File could not be downloaded.', NotificationTypes.danger);
			});
	};

	const onProceedClick = () => {
		setCurrentLoadingMessage({
			message: 'Starting normalization',
			text: '',
		});
		setPageLoading(true);
		triggerNormailzation(isAutomation)
			.then(() => {
				getCurrentEtlState();
				history.push(`/data/vendor-cleanup`);
			})
			.catch(err => {
				console.error(err);
				setPageLoading(false);
				showToast(
					'Normalization could not be started',
					NotificationTypes.danger,
					3000
				);
			});
	};

	const restartUpload = () => {
		setCurrentLoadingMessage({
			message: 'ETL process is being restarted',
			text: '',
		});
		setIsShowRestartModal(true);
	};

	return (
		<Wrapper>
			{/* <StepCount>Step 3: File Logs Review</StepCount> */}
			<StepCount>Step 3: File Clean Up</StepCount>
			{logFiles?.length === 0 ? (
				<TableWrapper>
					<FileSummary>
						<ImageWrapper>
							<ApIcon
								iconName="outline_error"
								iconSize="24px"
								iconColor={white}
							/>
						</ImageWrapper>
						No info logs were generated during file processing. You can proceed
						with the further process.
						<FlexAlignRight>
							<Tooltip
								title="Log file to review file errors."
								position="top"
								arrow={true}
							>
								<DownloadBtn onClick={downloadFile} id="tooltip-element">
									Download Log File
								</DownloadBtn>
							</Tooltip>
						</FlexAlignRight>
					</FileSummary>
				</TableWrapper>
			) : (
				<TableWrapper>
					<ErrorTable>
						<HeaderRow>
							{/* <HeaderValue>Unclassified file Logs</HeaderValue> */}
							<HeaderValue>File Clean Up Review</HeaderValue>
						</HeaderRow>

						<FileSummary>
							<ImageWrapper>
								<ApIcon
									iconName="outline_error"
									iconSize="24px"
									iconColor={white}
								/>
							</ImageWrapper>
							The below modifications have been made during file processing
							<FlexAlignRight>
								<Tooltip
									title="Log file to review file errors."
									position="top"
									arrow={true}
								>
									<DownloadBtn onClick={downloadFile} id="tooltip-element">
										Download Log File
									</DownloadBtn>
								</Tooltip>
							</FlexAlignRight>
						</FileSummary>
						<FileListWrapper>
							<FileList>
								{logFiles.map((error, index) => (
									<FileItem key={index}>{error}</FileItem>
								))}
							</FileList>
						</FileListWrapper>
					</ErrorTable>
				</TableWrapper>
			)}
			<ActionContainer>
				<RadioContainer>
					<NoteContainer>
						Select Option For Vendor Name Normalization:
					</NoteContainer>
					<ApRadio
						name="manual"
						onChange={() => setIsAutomation(false)}
						checked={isAutomation === false}
					>
						{/* <RadioLabel>Normalize vendor name manually</RadioLabel> */}
						<RadioLabel>Normalize/cleanse vendor name manually</RadioLabel>
					</ApRadio>
					<ApRadio
						name="automation"
						onChange={() => setIsAutomation(true)}
						checked={isAutomation === true}
					>
						<RadioLabel>Automate process & classify vendor spend</RadioLabel>
					</ApRadio>
				</RadioContainer>
				<ButtonWrapper>
					<ApButtonMain
						disabled={isAutomation === null}
						onClick={onProceedClick}
					>
						Proceed
					</ApButtonMain>
					<ApButtonSecondary
						style={{ color: 'orange', borderColor: 'orange' }}
						onClick={restartUpload}
					>
						Restart
					</ApButtonSecondary>
				</ButtonWrapper>
			</ActionContainer>
		</Wrapper>
	);
};

export default ErrorLogs;
